/**
 * Given an array of condition/message entries, we go through them until we find a failure,
 * then return the failure message.
 *
 * @param {Array.<[condition: boolean, message: string]>} cases
 * @param {boolean} [invert] - check for false instead of true
 * @return {string}
 */
export default function failureLadder(cases: FailureLadderCases, invert?: boolean): string {
    const found = cases
        .filter(c => !!c)
        .find(c => {
            return invert ? !c[0] : c[0];
        });
    if (found) return found[1];
    else return '';
}

export type FailureLadderCases = Array<[condition: boolean, message: string]>;